import axios from 'axios';
import { API_BASE } from './config';

/**
 * Start monitoring an address for deposits
 * @param params Object containing blockchain, address, and coin
 * @returns Result of the operation
 */
export const monitorAddress = async (params: {
  blockchain: string;
  address: string;
  coin?: string;
}) => {
  const { blockchain, address, coin } = params;

  const response = await axios.post(`${API_BASE}/debug/monitor-address`, {
    blockchain,
    address,
    coin
  });

  return response.data;
};

/**
 * Get detected deposits for a monitored address
 * @param blockchain Blockchain name
 * @param address Address to check for deposits
 * @returns List of detected deposits
 */
export const getDetectedDeposits = async (blockchain: string, address: string) => {
  if (!blockchain || !address) {
    return { status: 'success', deposits: [] };
  }

  const response = await axios.get(`${API_BASE}/debug/deposits`, {
    params: {
      blockchain,
      address
    }
  });

  return response.data;
};

/**
 * Stop monitoring an address
 * @param params Object containing blockchain and address
 * @returns Result of the operation
 */
export const stopMonitoringAddress = async (params: {
  blockchain: string;
  address: string;
}) => {
  const { blockchain, address } = params;

  const response = await axios.post(`${API_BASE}/debug/stop-monitoring`, {
    blockchain,
    address
  });

  return response.data;
};
